export default __webpack_public_path__ + "static/media/azure-sql-server.f1e77a67.svg";